import React from "react";
import { motion } from "framer-motion";
import { PROCESS_STEPS } from "../../data/site";

export const ManufacturingProcess = () => {
  return (
    <section data-testid="manufacturing-process" className="relative bg-[#FFFFFF] py-24 md:py-32 border-t border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="eyebrow mb-4">// Capability · 05</div>
            <h2 className="font-display uppercase tracking-tight text-slate-900 text-4xl md:text-6xl leading-[0.95] max-w-3xl">
              From <span className="text-[#0EA5E9]">CAD</span> to <span className="text-[#0EA5E9]">commissioning</span> — under one roof.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
          {PROCESS_STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.05 }}
              className="spec-card p-6 relative"
              data-testid={`process-step-${s.n}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-mono-wm text-3xl text-[#0EA5E9] font-bold">{s.n}</span>
                {i < PROCESS_STEPS.length - 1 && (
                  <span className="hidden lg:block w-6 h-px bg-[#0EA5E9]" />
                )}
              </div>
              <h3 className="font-display uppercase text-slate-900 text-base md:text-lg mt-6 tracking-tight leading-tight">{s.t}</h3>
              <p className="text-xs text-[#475569] mt-2 leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ManufacturingProcess;
